<template>
  <div>
    <!-- pc -->
    <div class="special_1">
      <div class="row1">
        <!-- 轮播图 -->
        <div class="carousel fl" @mouseenter="into" @mouseleave="leave">
          <a :href="picshref[index]" target="_blank">
            <img :src="pics[index]" alt="" style="border-style: none" />
          </a>
          <div class="pre" @click="pre" v-show="isShow" v-if="pics.length > 1">
            <img
              src="../../assets/img/prev.png"
              alt=""
              style="border-style: none"
            />
          </div>
          <div
            class="next"
            @click="next"
            v-show="isShow"
            v-if="pics.length > 1"
          >
            <img
              src="../../assets/img/next.png"
              alt=""
              style="border-style: none"
            />
          </div>
          <!-- <div class="point" v-show="isShow" v-if="pics.length > 1">
          <div
            class="pointer fl"
            v-for="item in pics.length"
            :key="item"
            @click="pointer(item)"
            :class="[item - 1 === index ? 'active' : '']"
          ></div>
        </div> -->
        </div>
        <div class="news fr">
          <ul>
            <li v-for="(item, index) in rightNews" :key="index">
              <i> </i>
              <a target="_blank" :href="item.docpuburl">{{ item.title }} </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row2">
        <div class="tags">
          <div
            v-for="(item, index) in bottomNews"
            :key="index"
            class="aTag fl"
            :class="{ active: isActive == index }"
            @click="tagClick(index)"
          >
            {{ item.name }}
          </div>
        </div>

        <div class="cards">
          <ul class="card1">
            <li
              v-for="(item, index) in bottomNews[isActive].list"
              :key="index"
              style="overflow: hidden"
            >
              <i> </i>
              <a
                v-show="item.index == bsIndex"
                target="_blank"
                :href="
                  'http://zwfw.nmg.gov.cn/handle_affairs_detail?item_detail_id=' +
                  item.docNo +
                  '&regionCode=' +
                  item.regionCode +
                  '&redirectFlag=true'
                "
                v-html="item.title"
              >
              </a>
              <a
                v-show="item.index != bsIndex"
                target="_blank"
                :href="item.docpuburl"
                v-html="item.title"
              >
              </a>
              <!-- <span class="date fr">
              {{ item.docpubtime | dataFormat }}
            </span> -->
            </li>
          </ul>
        </div>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="mobile">
      <div class="row1">
        <!-- 轮播图 -->
        <div class="carousel" @mouseenter="into" @mouseleave="leave">
          <a :href="picshref[index]" target="_blank">
            <img :src="pics[index]" alt="" style="border-style: none" />
          </a>
          <div class="pre" @click="pre" v-show="isShow" v-if="pics.length > 1">
            <img
              src="../../assets/img/prev.png"
              alt=""
              style="border-style: none"
            />
          </div>
          <div
            class="next"
            @click="next"
            v-show="isShow"
            v-if="pics.length > 1"
          >
            <img
              src="../../assets/img/next.png"
              alt=""
              style="border-style: none"
            />
          </div>
          <!-- <div class="point" v-show="isShow" v-if="pics.length > 1">
          <div
            class="pointer fl"
            v-for="item in pics.length"
            :key="item"
            @click="pointer(item)"
            :class="[item - 1 === index ? 'active' : '']"
          ></div>
        </div> -->
        </div>
        <div class="news">
          <ul>
            <li v-for="(item, index) in rightNews" :key="index">
              <i> </i>
              <a target="_blank" :href="item.docpuburl">{{ item.title }} </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row2">
        <div class="tags">
          <div
            v-for="(item, index) in bottomNews"
            :key="index"
            class="aTag fl"
            :class="{ active: isActive == index }"
            @click="tagClick(index)"
          >
            {{ item.name }}
          </div>
        </div>

        <div class="cards">
          <ul class="card1">
            <li
              v-for="(item, index) in bottomNews[isActive].list"
              :key="index"
              style="overflow: hidden"
            >
              <i> </i>
              <a
                v-show="item.index == bsIndex"
                target="_blank"
                :href="
                  'http://zwfw.nmg.gov.cn/handle_affairs_detail?item_detail_id=' +
                  item.docNo +
                  '&regionCode=' +
                  item.regionCode +
                  '&redirectFlag=true'
                "
                v-html="item.title"
              >
              </a>
              <a
                v-show="item.index != bsIndex"
                target="_blank"
                :href="item.docpuburl"
                v-html="item.title"
              >
              </a>
              <!-- <span class="date fr">
              {{ item.docpubtime | dataFormat }}
            </span> -->
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "v-special-idcard",
  components: {},
  props: {
    cScenceMap: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      isActive: 0,
      index: 0,
      // 定时器
      timer: null,
      isShow: false,
      bsIndex: "search_dev_item",
    };
  },
  watch: {},
  computed: {
    // 轮播图图片
    pics() {
      return this.cScenceMap.picPath.split(",");
    },
    // 轮播图图片地址
    picshref() {
      return this.cScenceMap.picHref.split(",");
    },
    // 右侧新闻
    rightNews() {
      return this.cScenceMap.scenceRightList;
    },
    // 下方新闻
    bottomNews() {
      return this.cScenceMap.scenceBottomList;
    },
  },
  methods: {
    tagClick(index) {
      this.isActive = index;
      // console.log(isAcitve);
    },
    // 轮播图
    next() {
      if (this.index < this.pics.length - 1) {
        this.index++;
      } else {
        this.index = 0;
      }
    },
    pre() {
      if (this.index > 0) {
        this.index--;
      } else {
        this.index = this.pics.length - 1;
      }
    },
    into() {
      clearInterval(this.timer);
      this.isShow = true;
    },
    leave() {
      this.timer = setInterval(() => {
        this.next();
      }, 3000);
      this.isShow = false;
    },
    pointer(e) {
      this.index = e - 1;
    },
  },
  created() {},
  mounted() {
    this.timer = setInterval(() => {
      this.next();
    }, 3000);
  },
  beforeDestroy() {
    // 页面关闭（路由跳转）时清除定时器
    clearInterval(this.timer);
    this.timer = null;
  },
};
</script>

<style lang="less" scoped>
.fl {
  float: left;
}
.fr {
  float: right;
}
@media screen and (min-width: 751px) {
  .mobile {
    display: none;
  }
  .special_1 {
    display: block;
    width: 832px;
    margin-bottom: 40px;
    // height: 406px;
    img {
      width: 350px;
      height: 194px;
    }
    .row1 {
      width: 832px;
      height: 196px;
      .carousel {
        width: 350px;
        height: 194px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      // 轮播图
      .pre {
        position: absolute;
        margin-top: -130px;
        width: 20px;
        height: 40px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .next {
        position: absolute;
        margin-top: -130px;
        margin-left: 330px;
        width: 20px;
        height: 40px;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .point {
        position: absolute;
        margin-top: -40px;
        margin-left: 100px;
      }
      .pointer {
        height: 15px;
        width: 15px;
        border-radius: 50px;
        background-color: grey;
        margin-right: 20px;
        cursor: pointer;
      }
      .active {
        background-color: rgb(1, 82, 147);
      }

      .news {
        ul {
          margin: 0;
          padding: 0;

          li {
            width: 430px;
            height: 28px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            i {
              display: inline-block;
              width: 15px;
              height: 15px;
              background-image: url(../../assets/img/pointer.png);
              background-size: 100% 100%;
              background-repeat: no-repeat;
              top: 10%;
              position: relative;
            }
            a {
              text-decoration: underline;
              color: #0042a2;
            }
          }
        }
      }
    }
    .row2 {
      width: 832px;
      height: 160px;
      margin-top: 15px;
      overflow: hidden;
      .tags {
        width: 832px;
        height: 30px;
        padding-bottom: 5px;
        border-bottom: 1px solid rgb(230, 230, 230);
        .aTag {
          font-size: 16px;
          margin: 0 10px;
          font-weight: bold;
          cursor: pointer;
          padding: 3px 10px 3px 10px;
        }
        .active {
          color: #ffffff;
          background-color: rgb(1, 82, 147);
          // color: rgb(1, 82, 147);
          // border-bottom: 1px solid rgb(1, 82, 147);
        }
      }
      .cards {
        width: 832px;
        margin-top: 10px;
        ul {
          width: 832px;
          margin: 0;
          padding: 0;
          li {
            width: 832px;
            height: 28px;
            font-size: 14px;
            line-height: 24px;
            i {
              display: inline-block;
              width: 15px;
              height: 15px;
              background-image: url(../../assets/img/pointer.png);
              background-size: 100% 100%;
              background-repeat: no-repeat;
              top: 10%;
              position: relative;
            }
            a {
              // text-decoration: underline;
              color: black;
            }
            a:hover {
              color: rgb(1, 82, 147);
            }
            span {
              // width: 80px;
              margin-left: 10px;
              text-align: right;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {
  @w: 7.5vw;

  .special_1 {
    display: none;
  }
  .mobile {
    display: block;
    width: 100%;
    padding-bottom: 10 / @w;
    border-bottom: 15 / @w solid rgb(230, 230, 230);
    margin-bottom: 20 / @w;
    // height: 406px;
    img {
      width: 350 / @w;
      height: 194 / @w;
    }
    .row1 {
      width: 100%;
      max-height: 720 / @w;
      .carousel {
        width: 750 / @w;
        height: 400 / @w;
        margin-bottom: 10 / @w;
        img {
          width: 100%;
          height: 100%;
        }
      }
      // 轮播图
      .pre {
        position: absolute;
        margin-top: -130 / @w;
        width: 20 / @w;
        height: 40 / @w;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .next {
        position: absolute;
        margin-top: -130 / @w;
        margin-left: 330 / @w;
        width: 20 / @w;
        height: 40 / @w;
        cursor: pointer;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .point {
        position: absolute;
        margin-top: -40 / @w;
        margin-left: 100 / @w;
      }
      .pointer {
        height: 15 / @w;
        width: 15 / @w;
        border-radius: 50 / @w;
        background-color: grey;
        margin-right: 20 / @w;
        cursor: pointer;
      }
      .active {
        background-color: rgb(1, 82, 147);
      }

      .news {
        ul {
          margin: 0;
          padding: 0;

          li {
            width: 740 / @w;
            height: 45 / @w;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            i {
              display: inline-block;
              width: 15 / @w;
              height: 15 / @w;
              background-image: url(../../assets/img/pointer.png);
              background-size: 100% 100%;
              background-repeat: no-repeat;
              top: -5%;
              position: relative;
            }
            a {
              text-decoration: underline;
              color: #0042a2;
            }
          }
        }
      }
    }
    .row2 {
      width: 750 / @w;
      height: 250 / @w;
      margin-top: 20 / @w;
      overflow: hidden;
      .tags {
        width: 750 / @w;
        height: 40 / @w;
        padding-bottom: 15 / @w;
        border-bottom: 1 / @w solid rgb(230, 230, 230);
        .aTag {
          // font-size: 16 / @w;
          margin: 0 10 / @w;
          font-weight: bold;
          cursor: pointer;
          padding: 3 / @w 10 / @w 3 / @w 10 / @w;
        }
        .active {
          color: #ffffff;
          background-color: rgb(1, 82, 147);
          // color: rgb(1, 82, 147);
          // border-bottom: 1px solid rgb(1, 82, 147);
        }
      }
      .cards {
        width: 740 / @w;
        margin-top: 10 / @w;
        ul {
          width: 740 / @w;
          margin: 0;
          padding: 0;
          li {
            width: 740 / @w;
            height: 45 / @w;
            // font-size: 14 / @w;
            line-height: 45 / @w;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            i {
              display: inline-block;
              width: 15 / @w;
              height: 15 / @w;
              background-image: url(../../assets/img/pointer.png);
              background-size: 100% 100%;
              background-repeat: no-repeat;
              top: -5%;
              position: relative;
            }
            a {
              // text-decoration: underline;
              color: black;
            }
            a:hover {
              color: rgb(1, 82, 147);
            }
            span {
              // width: 80px;
              margin-left: 10 / @w;
              text-align: right;
            }
          }
        }
      }
    }
  }
}
</style>